import React from 'react';

export const BusinessHours = ({ testId }) => (
  <dl className="business-hours" data-testid={testId}>
    <div><dt>Mon–Fri</dt><dd>8:00 AM – 6:00 PM</dd></div>
    <div><dt>Saturday</dt><dd>8:00 AM – 2:00 PM</dd></div>
    <div><dt>Sunday</dt><dd className="accent-text">Closed</dd></div>
  </dl>
);